import { createSlice } from '@reduxjs/toolkit';
import type { CreateBookingResponse, BookingError } from '../api/booking.types';
import { createBooking, cancelBooking, updateBookingQuantity } from './booking.thunk';

interface BookingState {
  loading: boolean;
  error: BookingError | null;
  lastCreated: CreateBookingResponse | null;
  updateLoading: boolean;
}

const initialState: BookingState = {
  loading: false,
  error: null,
  lastCreated: null,
  updateLoading: false,
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    clearBookingState: (state) => {
      state.error = null;
      state.lastCreated = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBooking.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createBooking.fulfilled, (state, action) => {
      state.loading = false;
      state.lastCreated = action.payload;
    });
    builder.addCase(createBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || {
        code: 500,
        message: 'Unknown booking error',
      };
    });

    builder.addCase(cancelBooking.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(cancelBooking.fulfilled, (state) => {
      state.loading = false;
      state.lastCreated = null;
    });
    builder.addCase(cancelBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || {
        code: 500,
        message: 'Unknown cancel error',
      };
    });


    builder.addCase(updateBookingQuantity.pending, (state) => {
      state.updateLoading = true;
      state.error = null;
    });
    builder.addCase(updateBookingQuantity.fulfilled, (state) => {
      state.updateLoading = false;
    });
    builder.addCase(updateBookingQuantity.rejected, (state, action) => {
      state.updateLoading = false;
      state.error = action.payload || {
        code: 500,
        message: 'Unknown update error',
      };
    });
  },
});

export const { clearBookingState } = bookingSlice.actions;
export default bookingSlice.reducer;